/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import config from '../../config/registerUser.config.json';
import axios from 'axios';
import { apiConfig } from '@/config/apiConfig';

export interface RegisterUserProps {
  email: string;
  firstName: string;
  lastName: string;
  password?: string;
  phoneNumber?: string;
  jwtToken?: string;
  headers: any;
}

export interface IRegisterUserMethods extends IPluginMethodMap {
  registerUser(args: any): Promise<any>;
}

export class RegisterUserService implements IAgentPlugin {
  readonly methods: IRegisterUserMethods;

  constructor() {
    this.methods = {
      registerUser: this.registerUser.bind(this),
    };
  }

  async registerUser(args: RegisterUserProps) {
    console.log(`registerUser service:`, args);
    try {
      const res = await axios.post(
        `${apiConfig?.rest?.url}${config?.registerEP}`,
        {
          email: args?.email,
          jwtToken: args?.jwtToken,
          phoneNumber: args?.phoneNumber,
          password: args?.password,
          firstName: args?.firstName,
          lastName: args?.lastName,
        },
        {
          headers: {
            ...args?.headers,
          },
        }
      );
      if (res?.data) {
        console.log(`Registered user res?.data`, res?.data);
        return res?.data;
      }
      // return true;
    } catch (err: any) {
      console.log(`Register user error`, err?.response?.data);
      throw Error(err?.response?.data?.error?.display_message);
    }
  }
}
